import { useMemo, useState } from 'react';
import Select from '../../components/Select/Select';
import { BANKS, DEAL_STEPS } from '../../constants';
import { ROLE_ADMIN } from '../../constants/roles';
import { textStyles } from '../../constants/textStyles';
import Button from '../../components/Button/Button';
import setStep from '../../api/deals/setStep';
import isUserHaveRole from '../../utils/isUserHaveRole';

const DealConfigureSteps = ({bankId, dealId, update}) => {
    const [statudId, setStatusId] = useState(null);

    const options = useMemo(() => {
        
        const bankKeys = Object.keys(BANKS);
        let bankName;

        for(let i of bankKeys) {
            if(BANKS?.[i] == bankId) {
                bankName = i;
            }
        }

        console.log("BANKID", bankId, bankName, DEAL_STEPS?.[bankName]);

        
        const otherOptions = [
            {
                label: "Доп.оборудование",
                value: 2,
            },
            {
                label: "Доп.услуги",
                value: 3,
            },
            {
                label: "Уточнение данных",
                value: 5,
            },
            {
                label: "Выбор Банка",
                value: 5,
            },
            {
                label: "Трёхсторонний договор",
                value: DEAL_STEPS.TRIPARTITE_CONTRACT,
            },
            {
                label: "Финал",
                value: 10,
            },
        ]

        if(!bankId || !bankName || !DEAL_STEPS?.[bankName]) return otherOptions;

        const keys = Object.keys(DEAL_STEPS?.[bankName]);

        const newOptions = keys?.map((key) => {
            return {
                label: key,
                value: DEAL_STEPS?.[bankName]?.[key]
            }
        });


        return [...otherOptions, ...newOptions];
    }, [bankId])
    
    // if(!bankId || !options) {
    //     return null;
    // }

    const submit = () => {
        // update может не прийти: на самостоятельном роуте /deals/deal/:id/credit
        // DealCredits рендерится без пропсов, и этап сохранялся бы, а страница
        // падала на update() и оставалась со старым состоянием.
        setStep({ dealId, step: statudId }).then(() => {
            update && update();
        });
    };

    if (!isUserHaveRole(ROLE_ADMIN)) {
        return;
    }

    return(<div>
        <p style={{ ...textStyles.formTitle, marginBottom: 20, marginTop: 40 }}>Редактирование этапа сделки:</p>

        <div style={{marginBottom: 20}}>
            <Select onChange={(option) => setStatusId(option?.value)} label="Этап сделки" options={options} />
        </div>
        <Button onClick={submit} fill disabled={!statudId}>Сохранить</Button>
    </div>)
}

export default DealConfigureSteps;